import React from 'react'
import RoleDelete from "./RoleDelete";
import RoleEdit from "./RoleEdit";
import RolePermission from "./RolePermission";

const RoleActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <RoleEdit  roleId={record.id}  updater={updater}/>
            <RoleDelete roleId={record.id} updater={updater} />
            <RolePermission roleId={record.id} updater={updater} />
        </React.Fragment>
    )
}
export default RoleActions